<template>
  <div class="dashboard-card">
    <div class="card-details">
      <p class="text-center"
									data-test="vendorStoreDetailsDashboardLabel"
									id="vendorStoreDetailsDashboardLabel">
        View Store Details
      </p>

    </div>
    <!-- action -->
    <div class="card-actions">
      <router-link
        type="button"
        class="btn btn-primary btn-type-primary"
        to="/pages/vendordashboard/view"
								data-test="vendorStoreDetailsDashboardViewLink"
								id="vendorStoreDetailsDashboardViewLink"
      >View</router-link>
    </div>
  </div>
</template>

<script>
export default {
	name: 'vendor-store-details-dashboard'
}
</script>

<style scoped>

</style>
